// extracted by mini-css-extract-plugin
module.exports = {"productsLink":"Products_productsLink__3NVey","electronicsLink":"Products_electronicsLink__29e9J"};